import { Observable } from "rxjs";
import { IPageRequest, IPagedResult, IResult } from "src/Shared/Interfaces";
import { ICompanyOffice } from "../Interfaces/ICompanyOffice";
import HttpClient from "src/Shared/Tools/HttpClient";
import { CompanyOfficeApiUrl } from "../Tools/CompanyOfficeApiUrls";
import { IOfficeFilter } from "../Interfaces/IOfficeFilter";
import { IAddCompanySites } from "../Interfaces";
import { BaseService } from "src/Shared/Services/Base.service";

class CompanyOfficeService extends BaseService {
  public getCompanyOfficesList(
    request: IPageRequest<IOfficeFilter>
  ): Observable<IPagedResult<ICompanyOffice>> {
    return this.http.post<IPagedResult<ICompanyOffice>>(
      // CompanyOfficeApiUrl.GetOffices + `?companyRowID=${request.filterCollection.companyRowID}`
      CompanyOfficeApiUrl.GetOffices,
      request
    );
  }

  public addCompanySite(request: ICompanyOffice[]) {
    return this.http.post<IResult<string>>(
      CompanyOfficeApiUrl.AddOffices,
      request
    );
  }

  public updateOffice(request: ICompanyOffice) {
    return this.http.post<IResult<string>>(
      CompanyOfficeApiUrl.UpdateOffices,
      request
    );
  }

  /** Removes a site and cleans up every reference to it (S3.8/S3.9). */
  public deleteOffice(companySiteID: number) {
    return this.http.post<IResult<string>>(CompanyOfficeApiUrl.DeleteOffice, {
      companySiteID,
    });
  }

  /** Writes one Imperans clinic onto every site, or clears it from all of them (story 6373). */
  public setSitesServicingClinic(request: {
    companyRowID: string;
    imperansFranchiseOfficeID: number | null;
    imperansFranchiseOfficeName: string | null;
  }) {
    return this.http.post<IResult<string>>(CompanyOfficeApiUrl.SitesServicingClinic, request);
  }

  /** The distinct regions a client's sites cover — its national coverage (S3.4). */
  public getSiteRegions(companyRowID: string) {
    return this.http.get<{ value: number; label: string }[]>(
      CompanyOfficeApiUrl.SiteRegions(companyRowID),
    );
  }

  public getPrimaryOfficeID(companyRowID: string) {
    return this.http.get<number | null>(
      CompanyOfficeApiUrl.GetPrimaryOfficeID(companyRowID)
    );
  }
}

export default new CompanyOfficeService();
